import BranchDetails from './branch-details';

export default BranchDetails;
